import type { Nullable } from '@ats/interfaces';
import ContentTile from '@components/ContentTile';
import type { BaseComponentProps } from '@interfaces/selection';
import { useAudioVideo } from '@providers/AudioVideoProvider';
import { useContentShareState } from '@providers/ContentShareProvider';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useRef } from 'react';

interface ContentShareProps extends BaseComponentProps {
  nameplate?: string;
}

const ContentShare: FC<PropsWithChildren<ContentShareProps>> = ({
  className,
  ...rest
}) => {
  const audioVideo = useAudioVideo();
  const { tileId } = useContentShareState();
  const videoEl = useRef<Nullable<HTMLVideoElement>>(null);

  useEffect(() => {
    if (!audioVideo || !videoEl.current || !tileId) return;

    audioVideo.bindVideoElement(tileId, videoEl.current);

    return () => {
      const tile = audioVideo.getVideoTile(tileId);

      if (tile) {
        audioVideo.unbindVideoElement(tileId);
      }
    };
  }, [audioVideo, tileId]);

  return (
    <ContentTile className={className || ''} {...rest}>
      <video ref={videoEl} className='ch-video' />
    </ContentTile>
  );
};

export default ContentShare;
